module.exports = __webpack_public_path__ + "img/card-logo-3.18b93668.svg";